<script setup lang="ts">
import { router } from '@inertiajs/vue3';
import HelpSelection from '@/components/forms/HelpSelection.vue';
import BannerSection from '@/components/home/BannerSection.vue';
import CategoriesSection from '@/components/home/CategoriesSection.vue';
import FeaturesSection from '@/components/home/FeaturesSection.vue';
import OfferSection from '@/components/home/OfferSection.vue';
import HitSection from '@/components/product/HitSection.vue';
import AppLayout from '@/layouts/AppLayout.vue';
import type { Category } from '@/types/category';
import type { MainBannerSlide } from '@/types/main-banner';
import type { Product } from '@/types/product';
import { Offer } from '@/types/offer';
import AppHead from '@/layouts/AppHead.vue';

interface Props {
  hitProducts?: Product[];
  categories?: Category[];
  offers?: Offer[];
  main_banners: MainBannerSlide[];
}

const props = withDefaults(defineProps<Props>(), {
  hitProducts: () => [],
  categories: () => [],
  offers: () => [],
});

router.reload({ replace: true, only: ['hitProducts', 'categories', 'offers'] });
</script>

<template>
  <AppHead title="Главная" />
  <AppLayout>
    <BannerSection v-if="main_banners.length > 0" :slides="main_banners" />
    <FeaturesSection />
    <CategoriesSection v-if="categories.length > 0" :categories="categories" />
    <HitSection v-if="hitProducts.length > 0" :products="hitProducts" />
    <OfferSection v-if="offers.length > 0" :offers="offers" />
    <HelpSelection />
  </AppLayout>
</template>
